import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ArrowLeftOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M11.8408 18.7437L5.83377 12.7366L21.9961 12.7366V10.7368H5.82272L11.8118 4.74757L10.3976 3.33334L1.99992 11.7312L10.4266 20.1579L11.8408 18.7437Z",
    fill: "currentColor"
  }));
}